// extracted by mini-css-extract-plugin
export var container = "_bv-0";